export const issueFields = {
  number: null,
  id: "",
  title: "",
  projectType: "", // "no-cost" | "corpus" | "fund-raise"
  consider: "",
  priority: "",
  resolutionType: "",
  frequency: "",
  description: "",
  whereIssueIdentified: "",
  whereIssueIdentifiedCategory: "",
  whereIssueIdentifiedLocate: "",
  whereFixNeeded: "",
  whereFixNeededCategory: "",
  whereFixNeededLocate: "",
  whereFixGiven: "",
  whereFixGivenCategory: "",
  whereFixLocate: "",
  category: "",
  status: "open",
  progress: 0,
};

export const initialState = {
  issues: [],
  issue: {
    ...issueFields,
  },
};
